import * as React from "react";
import {Table} from "semantic-ui-react";
import AceEditor from "react-ace";

import 'brace/theme/monokai'
import 'brace/ext/searchbox'
import ace from "ace-builds";

export interface RespondHttpViewerProps {
    output: string
}


export function RespondHttpViewer(props: React.PropsWithChildren<RespondHttpViewerProps>) {

    const [respondHttp, setRespondHttp] = React.useState<RespondHttp | null>(null)
    const [parsedBody, setParsedBody] = React.useState<any>(null);
    const [message, setMessage] = React.useState<string>("");
    const [aceMode, setAceMode] = React.useState<string>("xml");

    React.useEffect(() => {
        if (props.output) {
            try {
                let parsed = JSON.parse(props.output);
                console.log("parsed: ", parsed)
                setRespondHttp(parsed);
                let pb = JSON.parse(parsed.stringBody)
                setParsedBody(pb)
                setMessage(getMessage(pb, parsed.stringBody))
                console.log("parsedBody: ", pb)
            } catch (e) {
                console.error("Failed to parse output as RespondHttp:", e);
                setRespondHttp(null);
            }
        }
    }, [props.output]);

    function displayHeaders() {

        let headers = []
        if (respondHttp?.headers) {
            for (let key in respondHttp.headers) {
                headers.push(
                    <div>
                        {key}: {respondHttp.headers[key]}
                    </div>
                )
            }
        }
        return headers
    }

    function DisplayRespondHttp(respondHttp: RespondHttp) {

        return <>
            <Table celled striped>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell>Method</Table.Cell>
                        <Table.Cell>{respondHttp.method}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>URL</Table.Cell>
                        <Table.Cell>{respondHttp.url}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>Headers</Table.Cell>
                        <Table.Cell>{displayHeaders()}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>MessageName</Table.Cell>
                        <Table.Cell>{parsedBody?.MessageName}</Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
            <AceEditor
                mode={aceMode}
                theme="monokai"
                value={message}
                readOnly={true}
                width="100%"
                height="100%"
            />
        </>
    }

    function getMessage(parsedBody: any, rawBody: string): string {
        if(parsedBody?.messageData) {
            return parsedBody.messageData.ObjectString || ""
        }


        let mode = "text";
        try {
            JSON.parse(rawBody);
            mode = "json";
        } catch {
            if (/^\s*<\?xml|<[\w]+/.test(rawBody)) {
                mode = "xml";
            }
        }
        setAceMode(mode);
        return rawBody || ""
    }



    return <>
        {respondHttp && DisplayRespondHttp(respondHttp)}
    </>

}

interface RespondHttp {
    base64Body: string | null;
    headers: {
        "Content-Type": string;
    };
    method: string;
    stringBody: string;
    url: string;
}

